<template>
<div class="container menu animated rubberBand">
  <div class="columns is-mobile is-full">
    <a class="column menu-item"
      @click="select('home')">
      <font-awesome-icon icon="home" />
      <div class="menu-item-label">home</div>
    </a>
    <a class="column menu-item"
      href="#rsvp"
      @click="select('rsvp')">
      <font-awesome-icon icon="edit" />
      <div class="menu-item-label">rsvp</div>
    </a>
    <a class="column menu-item"
      href="#travel"
      @click="select('travel')">
      <font-awesome-icon icon="info-circle" />
      <div class="menu-item-label">faq</div>
    </a>
    <a class="column menu-item"
      href="#hotels"
      @click="select('hotels')">
      <font-awesome-icon icon="bed" />
      <div class="menu-item-label">hotels</div>
    </a>
    <a class="column menu-item"
      href="#schedule"
      @click="select('schedule')">
      <font-awesome-icon icon="calendar-alt" />
      <div class="menu-item-label">schedule</div>
    </a>
  </div>
</div>
</template>

<script>
import 'animate.css/animate.css';

export default {
  name: 'DefaultMenu',
  props: {
    activeTab: String
  },
  methods: {
    select: function (tabId) {
      console.log('Emitting tab', tabId);
      this.$emit('update:activeTab', tabId);
    }
  }
}
</script>

<style>
.container {
  z-index: 10;
}

.menu {
  position: absolute;
  background-color: rgba(255, 255, 255, 0.1);
  z-index: 10;
  width: 100% !important;
  text-align: center;

  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.menu-item {
  text-align: center;
  padding: 1.5em 1em !important;
  width: 1em;
  z-index: 1000;
  cursor: pointer;
  width: 10px;
  color: black;
}

.menu-item-label {
  font-size: .8em;
}

.menu-item:not(:last-child) {
  border-right: 1px dashed rgba(164, 134, 107, 0.4);
}

.menu-item:active {
  background-color: rgba(164, 134, 107, 0.4);
}

@media (max-width: 768px) {
  .menu {
    background-color: white;
    position: fixed !important;
    width: 100% !important;
    padding: 1em;
    bottom: 0;
  }
}

.icon {
  color: white;
  font-size: 2em;
  width: 1em;
  z-index: 1000;
  cursor: pointer;
}

.fullscreen-video {
  position: fixed;
  right: 0;
  bottom: 0;
  min-width: 100%;
  min-height: 100%;
  width: 100% !important;
  height: 100% !important;
}
</style>
